import React from 'react';

import DatePicker from 'components/DatePicker';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import { SectionState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function RoundsSection({
  rounds, open, onToggle,
}: SectionState & {
  rounds: {
    selectedRounds: Date[];
    setRounds: (dates: Date[]) => unknown;
    availableIntervals: { start: Date; end: Date }[];
  };
}) {
  return (
    <Section
      label="Rodadas"
      valueText={rounds.selectedRounds.length
        ? `${rounds.selectedRounds.length} selecionadas` : undefined}
      open={open}
      onToggle={onToggle}
    >
      <DatePicker
        inline
        showMonthDropdown
        showYearDropdown
        selectsMultiple
        onChange={(dates) => rounds.setRounds(dates || [])}
        selectedDates={rounds.selectedRounds}
        includeDateIntervals={rounds.availableIntervals}
      />
    </Section>
  );
}
